<template>
  <div class="chart-wrap" v-loading="loading">
    <echart
      chartId="proportion-of-category"
      :height="height"
      :options="options"
      :not-merge="notMerge"
    ></echart>

    <div v-if="!data || !data.length" class="no-data">
      <span>暂无数据</span>
    </div>
  </div>
</template>

<script>
import Echart from '@/components/Chart'

export default {
  components: { Echart },
  props: {
    loading: Boolean,
    data: {
      type: Array,
      required: true
    },
    notMerge: { type: Boolean, default: false }
  },
  data() {
    return {
      height: 170
    }
  },
  computed: {
    options() {
      return {
        title: { show: false },
        xAxis: { show: false },
        yAxis: { show: false },
        toolbox: { show: false },
        selectedMode: 'single',
        legend: {
          type: 'scroll',
          bottom: 24,
          left: '5%',
          right: '5%',
          pageIconSize: 14,
          itemGap: 4,
          textStyle: { fontSize: 14 },
          pageTextStyle: { fontSize: 14 }
        },
        tooltip: {
          trigger: 'item',
          formatter(item) {
            return `
            <div
              style="display: inline-block;
              border-radius: 50%;
              width: 12px;
              height: 12px;
              background-color:${item.color};"
            >
            </div>
            ${item.name} </br>
            ${item.value} ( ${item.percent}% )
            `
          }
        },
        series: [
          {
            type: 'pie',
            center: ['50%', (this.height - 50) / 2],
            radius: [0, (this.height - 100) / 2],
            label: { show: false },
            data: this.data.map(d => ({ name: d.category, value: d.qty }))
          }
        ]
      }
    }
  },
  mounted() {
    this.height = this.$el.offsetHeight
  }
}
</script>
